export default __webpack_public_path__ + "static/media/element_82.9da72a75.webp";